import request from '../utils/request'

/**
 * 后面的每次请求都是需要携带token的
 */

//获取新闻列表
export const newsList= () => {
  return request({
    url: "/news/all",
    method: 'get',
  })
}

//分页获取新闻列表
export const getNewsByType= (params) => {
  return request({
    url: "/news",
    method: 'get',
    params:params
  })
}

//获取新闻详情
export const newsDetail = (id) => {
  return request({
    url: `/news/details`,
    method: 'get',
    params:{
      id:id
    }
  })
}

